import ProductExcel from '@/types/app/productsExcel';
import { ProductExcelStateInterface } from './types';

export default {
  setProductsToExcel(
    state: ProductExcelStateInterface,
    productsExcel: ProductExcel[]
  ) {
    state.productsToExcel = productsExcel;
  },
  setIsSavingFile(state: ProductExcelStateInterface, isSaving: boolean) {
    state.isSavingFile = isSaving;
  },
  setIsExportingFile(state: ProductExcelStateInterface, isExporting: boolean) {
    state.isExportingFile = isExporting;
  }
};
